import { render, staticRenderFns } from "./datosCliente.vue?vue&type=template&id=04c6e012&"
import script from "./datosCliente.vue?vue&type=script&lang=js&"
export * from "./datosCliente.vue?vue&type=script&lang=js&"
import style0 from "./datosCliente.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports